import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["as", "autoRepeat", "minWidth", "children"];
import styled from 'styled-components';
import { Layout } from './Layout';
import { jsx as _jsx } from "react/jsx-runtime";
const defaultMinWidth = '20rem';
const StyledLayoutGrid = styled(Layout).withConfig({
  displayName: "LayoutGridAuto__StyledLayoutGrid",
  componentId: "sc-1nc1ysm-0"
})(["", ""], ({
  $autoRepeat,
  $minWidth
}) => `grid-template-columns: repeat(
    ${$autoRepeat},
    minmax(${$minWidth}, 1fr)
  );`);
export const LayoutGridAuto = _ref => {
  let {
      as,
      autoRepeat = 'auto-fill',
      minWidth = defaultMinWidth,
      children
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/_jsx(StyledLayoutGrid, Object.assign({}, rest, {
    $autoRepeat: autoRepeat,
    $minWidth: minWidth,
    display: "grid",
    forwardedAs: as,
    children: children
  }));
};